module.exports = __webpack_public_path__ + "static/media/bluecap2.4e77009f.png";